"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _react = _interopRequireDefault(require("react"));
function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    width: "4",
    height: "15"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 5.333a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 5.334a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }));
}
//# sourceMappingURL=Toggle.js.map